import {
  UseInfiniteQueryResult,
  UseQueryResult,
  useInfiniteQuery,
  useQuery,
} from "@tanstack/react-query";
import { axiosProperty, throwResponse } from "config/axios";
import { IDashboardParcelStatus, IDashboardParcelAverage } from "./interface";
import {
  IDashboardGraph,
  IDashboardName,
  IDashboardParams,
  IDashboardUnitNumber,
} from "../../interface";
import { IResponse } from "config/axios/interface";

export const useGetPropertyDashboardParcel = (
  params?: IDashboardParams
): UseQueryResult<IDashboardParcelStatus, Error> => {
  return useQuery(
    ["dashboard-property-parcel", "all", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/most-parcel-by-status",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardParcelAverage = (
  params?: IDashboardParams
): UseQueryResult<IDashboardParcelAverage, Error> => {
  return useQuery(
    ["dashboard-property-parcel", "average", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/interval-three-months",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      keepPreviousData: true,
    }
  );
};
export const useGetPropertyDashboardParcelByStatus = (
  params?: IDashboardParams
): UseQueryResult<IDashboardParcelStatus, Error> => {
  return useQuery(
    ["dashboard-property-parcel", "most-parcel-by-status", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/most-parcel-by-status",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardParcelType = (
  params?: IDashboardParams
): UseQueryResult<IDashboardName[], Error> => {
  return useQuery(
    ["dashboard-property-parcel", "type", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/most-parcel-types",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardParcelUnit = (
  params?: IDashboardParams
): UseQueryResult<IDashboardUnitNumber[], Error> => {
  return useQuery(
    ["dashboard-property-parcel", "unit", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/most-unit-used-parcel",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

// scroll
export const useScrollGetPropertyDashboardParcelType = (
  params?: IDashboardParams
): UseInfiniteQueryResult<IResponse<IDashboardName[]>, Error> => {
  return useInfiniteQuery(
    ["dashboard-property-parcel", "type", "scroll", params],
    async ({ pageParam }) => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/most-parcel-types",
        {
          params: { ...params, ...pageParam },
        }
      );
      if (res.status === 200) {
        return res.data;
      }
      throwResponse(res);
    },
    { enabled: params?.enabled }
  );
};

export const useScrollGetPropertyDashboardParcelUnit = (
  params?: IDashboardParams
): UseInfiniteQueryResult<IResponse<IDashboardUnitNumber[]>, Error> => {
  return useInfiniteQuery(
    ["dashboard-property-parcel", "unit", "scroll", params],
    async ({ pageParam }) => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/most-unit-used-parcel",
        {
          params: { ...params, ...pageParam },
        }
      );
      if (res.status === 200) {
        return res.data;
      }
      throwResponse(res);
    },
    { enabled: params?.enabled }
  );
};

export const useGetPropertyDashboardParcelPerDay = (
  params?: IDashboardParams
): UseQueryResult<IDashboardGraph[], Error> => {
  return useQuery(
    ["dashboard-property-parcel", "count-parcel-per-day", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/count-parcel-per-day",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetPropertyDashboardParcelAvgDate = (
  params?: IDashboardParams
): UseQueryResult<IDashboardGraph[], Error> => {
  return useQuery(
    ["dashboard-property-parcel", "graph-avg", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/post-parcel/graph-avg-post-parcel-date",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
